'use client';

import { faShare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/ui/components/ui/button';
import { toast } from 'react-toastify';

import { ModalWrapper } from '@/components/organisms';
import { useOrganizationStore } from '@/store/organization-store';
import { generateInvitationMessage } from '@/utils/helpers';

interface ResendInvitationFormProps {
	title: string;
	invitationCode?: string;
	onClose: () => void;
	leagueTitle: string;
	seasonUuid: string;
}

export const InviteOrResendCodeModal = ({ title, invitationCode, onClose, leagueTitle, seasonUuid }: ResendInvitationFormProps) => {
	const organizationStore = useOrganizationStore();
	const { teamLeagueUuid, organizationUuid } = organizationStore;

	return (
		<ModalWrapper title={title} onClose={onClose} className="z-50 !mx-10 max-w-[524px] !gap-0 !p-6">
			<div>
				<div className="my-[18px] flex items-center text-base font-bold leading-6 text-gray-800">
					<span>Current code:</span>
					<span className="ml-1 text-base font-bold leading-6 text-[#36F]">{invitationCode}</span>
				</div>

				<hr className="mb-6 h-px rounded-md bg-[#AB95EA]" />

				<span className="text-base font-medium leading-6 text-gray-900">Click Share the code to copy to clipboard and paste to share.</span>

				<Button
					onClick={() => {
						const clipboardText = generateInvitationMessage(
							leagueTitle,
							invitationCode || '',
							organizationUuid,
							teamLeagueUuid,
							seasonUuid
						);
						navigator.clipboard.writeText(clipboardText);
						toast.success('Code copied to clipboard.');
						onClose();
					}}
					type="submit"
					className="mt-[50px] h-12 w-full text-base font-semibold leading-7"
				>
					<FontAwesomeIcon icon={faShare} />
					<span className="ml-2">Share the code</span>
				</Button>
			</div>
		</ModalWrapper>
	);
};
